import script from "./ModalHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ModalHeader.vue?vue&type=style&index=0&id=47e01768&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e01768"]])

export default __exports__